import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daf8g8rep053ijub1l2g";

export default function SubscribeSection() {
  const [status, setStatus] = useState<"idle" | "ok" | "err">("idle");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get("contact_alt") || "").trim();
    if (honeypot) {
      setStatus("ok");
      setMessage("已收到你的订阅请求，投稿干货正在路上。");
      form.reset();
      return;
    }

    data.delete("contact_alt");

    setLoading(true);
    setStatus("idle");
    setMessage("");
    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = text ? JSON.parse(text) : null;
      } catch {
        parsed = null;
      }
      const meta = (parsed?.meta || {}) as Record<string, unknown>;
      const serverMsg =
        (meta?.message as string) || (parsed?.message as string) || (meta?.detail as string) || "";
      const ok = res.ok && parsed?.code === "OK";

      if (ok) {
        setStatus("ok");
        setMessage("订阅成功！后续会把吃瓜投稿的稿费与提现干货发给你。");
        form.reset();
      } else {
        setStatus("err");
        setMessage(
          (serverMsg && String(serverMsg).includes("spam")
            ? "提交未成功，请稍后再试。"
            : serverMsg) || "提交失败，请检查邮箱后重试。"
        );
      }
    } catch {
      setStatus("err");
      setMessage("网络异常，请稍后再试。");
    } finally {
      setLoading(false);
    }
  }

  return (
    <section id="subscribe" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 pb-16 pt-4 md:px-6 md:pb-20">
      <div className="grid items-center gap-10 overflow-hidden rounded-[2rem] bg-primary-500 px-6 py-10 text-background-50 md:grid-cols-2 md:px-12 md:py-14">
        <div>
          <h2 className="text-3xl leading-snug text-background-50 md:text-4xl">
            订阅投稿指南，少走弯路
          </h2>
          <p className="mt-4 max-w-lg leading-relaxed text-background-100 md:text-lg">
            留下邮箱，吃瓜投稿的稿费单价变化、结算与提现技巧不定期更新，把赚钱路径和到账规则讲得更透。
          </p>
          <ul className="mt-6 space-y-2 text-sm text-background-100 md:text-base">
            <li className="flex items-center gap-2">
              <i className="ri-mail-check-line" aria-hidden="true"></i> 不定期投稿情报更新
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-shield-check-line" aria-hidden="true"></i> 放心订阅，随时可退订
            </li>
          </ul>
        </div>

        <form
          className="rounded-3xl bg-background-50 p-6 ring-1 ring-black/5 md:p-7"
          onSubmit={handleSubmit}
          data-readdy-form
        >
          <input
            type="text"
            name="contact_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="contact-alt-hidden"
          />
          <label htmlFor="sub-email" className="text-sm font-medium text-foreground-800">
            邮箱地址
          </label>
          <div className="mt-2 flex flex-col gap-3 sm:flex-row">
            <input
              id="sub-email"
              name="email"
              type="email"
              required
              placeholder="name@example.com"
              className="w-full rounded-full border border-background-200 bg-background-50 px-5 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
            <button
              type="submit"
              disabled={loading}
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-70"
            >
              {loading ? "提交中…" : "订阅指南"}
            </button>
          </div>
          {status === "ok" && (
            <p className="mt-3 flex items-center gap-1.5 text-sm font-medium text-accent-700">
              <i className="ri-checkbox-circle-fill" aria-hidden="true"></i> {message}
            </p>
          )}
          {status === "err" && (
            <p className="mt-3 flex items-center gap-1.5 text-sm font-medium text-primary-700">
              <i className="ri-error-warning-line" aria-hidden="true"></i> {message}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}